import axios from "axios";
import { authHeader } from "./headerConfig";
const API_ENDPOINT = process.env.REACT_APP_ENDPOINT + "/api/x-admin";

const addCustomPrice = async (data) => {
  const response = await axios.post(`${API_ENDPOINT}/custom-prices`, data, {
    withCredentials: true,
    headers: {
      ...authHeader(),
    },
  });
  return response;
};

const getCustomPrice = async (id) => {
  const response = await axios.get(`${API_ENDPOINT}/custom-prices/${id}`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });
  return response;
};

const editCustomPrice = async (data ,id) => {
  const response = await axios.put(`${API_ENDPOINT}/custom-prices/${id}`, data, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });
  return response;
};
const getAllCustomPricesBySubitem = async (id, page = 1) => {
  const response = await axios.get(
    `${API_ENDPOINT}/subitems/${id}/custom-prices?page=${page}`,
    {
      withCredentials: true,
      headers: {
        ...authHeader(),
        Accept: "application/json",
      },
    }
  );

  return response.data;
};
const deleteCustomPrice = (id) => {
  return axios.delete(`${API_ENDPOINT}/custom-prices/${id}`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });
};
const customPriceServices = {
  addCustomPrice,
  getCustomPrice,
  editCustomPrice,
  getAllCustomPricesBySubitem,
  deleteCustomPrice,
};

export default customPriceServices;
